import { useContext, useContextSelector } from 'use-context-selector';
import { APIGatewayResponse } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';
import { AxiosError } from 'axios';
import AuthorizationContext from './NotificationsContext';

const useNotificationsState = () => {
  const context = useContext(AuthorizationContext);

  if (context === undefined) {
    throw new Error('useNotificationsState must be used within NotificationsProvider');
  }

  return context;
};

const useNotificationsAuthorizationsList = () => {
  const context = useContextSelector(AuthorizationContext, state => state.authorizationsList);

  if (context === undefined) {
    throw new Error('useNotificationsAuthorizationsList must be used within NotificationsProvider');
  }

  return context;
};

const useNotificationsTransactionsList = () => {
  const context = useContextSelector(AuthorizationContext, state => state.transactionsList);

  if (context === undefined) {
    throw new Error('useNotificationsTransactionsList must be used within NotificationsProvider');
  }

  return context;
};

const useNotificationsPayrollList = () => {
  const context = useContextSelector(AuthorizationContext, state => state.payrollList);

  if (context === undefined) {
    throw new Error('useNotificationsPayrollList must be used within NotificationsProvider');
  }

  return context;
};

const useNotificationsLoadingState = (loadingProperty: 'isLoadingPendingAuthorizations') => {
  const context = useContextSelector(AuthorizationContext, state => state.loadingState);

  if (context === undefined) {
    throw new Error('useNotificationsLoadingState  must be used within NotificationsProvider');
  }

  return context[loadingProperty];
};

const useNotificationsErrorState = (
  errorProperty: 'pendingAuthorizationsListError',
): AxiosError<APIGatewayResponse<unknown>, any> | undefined => {
  const context = useContextSelector(AuthorizationContext, state => state.errorState);

  if (context === undefined) {
    throw new Error('useNotificationsErrorState must be used within NotificationsProvider');
  }

  return context[errorProperty];
};

const useOnRefetchPendingAuthizationsListMutation = () => {
  const context = useContextSelector(AuthorizationContext, state => state.onRefetchPendingAuthizationsListMutation);

  if (context === undefined) {
    throw new Error('useOnRefetchPendingAuthizationsListMutation must be used within NotificationsProvider');
  }

  return context;
};

export {
  useNotificationsState,
  useNotificationsAuthorizationsList,
  useNotificationsTransactionsList,
  useNotificationsPayrollList,
  useNotificationsLoadingState,
  useNotificationsErrorState,
  useOnRefetchPendingAuthizationsListMutation,
};
